import React from 'react';
import { Card, Alert, ListGroup } from 'react-bootstrap';
import { BsCheckCircleFill, BsFolderFill, BsLockFill } from 'react-icons/bs';
// import { GoTerminal } from 'react-icons/go';
// import { MdOutlineCreate } from 'react-icons/md';

import 'bootstrap/dist/css/bootstrap.min.css';
import './WelcomeScreen.css';
import { Briefcase, TerminalFill } from 'react-bootstrap-icons';
import { useNavigate } from 'react-router-dom';
import { UserType } from '../../App';
import ResumeUpload from '../ResumeUpload';

interface WelcomeScreenProps {
  user: UserType | null;
  setUser: React.Dispatch<React.SetStateAction<UserType | null>>;
  refreshUser: () => void;
}

const WelcomeScreen: React.FC<WelcomeScreenProps> = (props) => {
  const { user, setUser, refreshUser } = props;
  //const [showModal, setShowModal] = useState(false);
  //const [user, setUser] = useState<any>(null);
  const navigate = useNavigate();
  return (
    <>
      <div className="container welcome-screen-container">
        <Card className="p-4 shadow-sm rounded-4 inter-style welcome-screen-card">
          {user?.firstName && (
            <h4 className="mb-3 welcome-screen-heading">
              <span role="img" aria-label="waving hand">
                👋
              </span>{' '}
              Welcome to SkipScreen, {user.firstName}!
            </h4>
          )}

          <p className="welcome-screen-intro">
            Your profile has been created. To activate your profile and be visible:
          </p>

          <ListGroup variant="flush" className="mb-3 welcome-screen-checklist">
            <ListGroup.Item className="d-flex align-items-start gap-2 border-0">
              {/* <BsCheckCircleFill size={20} className="text-success mt-1" /> */}
              {
                BsCheckCircleFill({
                  size: 20,
                  className: 'text-success mt-1',
                }) as unknown as JSX.Element
              }

              <div>
                <strong>
                  Start with a <span className="text-success">Screening Prompt</span>
                </strong>{' '}
                – This is your chance to showcase how you think, work, and solve problems. It’s the
                primary way recruiters evaluate fit beyond your resume.
              </div>
            </ListGroup.Item>

            <ListGroup.Item className="d-flex align-items-start gap-2 border-0">
              {
                BsFolderFill({
                  size: 24,
                  className: 'text-success',
                }) as unknown as JSX.Element
              }

              <div>
                <strong>Add a Portfolio</strong> – Highlight past projects, accomplishments, and
                contributions that reflect your strengths and experience.
              </div>
            </ListGroup.Item>

            <ListGroup.Item className="d-flex flex-column gap-2 border-0">
              <div className="d-flex align-items-start gap-2">
                {
                  BsFolderFill({
                    size: 20,
                    className: 'text-success mt-1',
                  }) as unknown as JSX.Element
                }
                <div>
                  <strong>Upload Your Resume</strong> – Share your latest resume for recruiter
                  review.
                </div>
              </div>

              <div className="ms-4">
                <ResumeUpload
                  existingResumeUrl={user?.resume}
                  existingResumeFileName={user?.resumeFileName}
                  uploadImmediately
                  showLabel={false}
                  onUploadSuccess={(fileUrl, fileName) => {
                    setUser((prev) =>
                      prev
                        ? {
                            ...prev,
                            resume: fileUrl,
                            resumeFileName: fileName || prev.resumeFileName,
                          }
                        : prev
                    );
                    refreshUser();
                  }}
                />
              </div>
            </ListGroup.Item>
          </ListGroup>

          <Alert variant="light" className="d-flex align-items-center gap-2 welcome-screen-note">
            {/* <BsLockFill size={16} /> */}
            {
              BsLockFill({
                size: 16,
                className: 'text-success',
              }) as unknown as JSX.Element
            }

            <small className="text-muted m-0">
              <strong>Note:</strong> Your profile remains hidden until you complete at least one
              screening prompt.
            </small>
          </Alert>

          <hr className="welcome-screen-divider" />

          <div className="mb-3 welcome-screen-steps">
            <div>
              <strong>Step 1 of 2</strong>
            </div>
            <Card
              className="bg-success-subtle p-3 mb-3 rounded-3 border-0 hover-float"
              style={{ cursor: 'pointer' }}
              onClick={() => navigate('/create-prompt')}
            >
              <div className="d-flex align-items-center gap-2">
                <TerminalFill className="text-success" size={24} />
                <div>
                  <div className="fw-semibold">Create Screening Prompts</div>
                  <div className="small text-muted">Required</div>
                </div>
              </div>
            </Card>

            <div>
              <strong>Step 2 of 2</strong>
            </div>
            <Card
              className="bg-light p-3 rounded-3 border-0 hover-float disabled-card"
              style={{
                cursor: 'not-allowed',
                pointerEvents: 'none',
                opacity: 0.6,
              }}
            >
              <div className="d-flex align-items-center gap-2">
                <Briefcase className="text-success" size={24} />
                <div>
                  <div className="fw-semibold">Create Portfolio</div>
                  <div className="small text-muted">Optional</div>
                </div>
              </div>
            </Card>
          </div>
        </Card>
      </div>
    </>
  );
};

export default WelcomeScreen;
